import { jwtDecode } from "jwt-decode";
import moment from 'moment';
import { useEffect } from 'react';
import { sessions } from '../common/localstorage/SessionStorage';
import { DecodeToken } from '../features/login/models';


const useTokenExpirationCheck = () => {
  useEffect(() => {
    // Function to check token expiration
    const checkTokenExpiration = () => {
      const token = sessions.getToken(); // Retrieve the token
      if (token) {
        const decoded = jwtDecode<DecodeToken>(token); // Decode token

        if (decoded.exp) {
          const expirationDate = moment.unix(decoded.exp); // Token expiration date
          const currentDate = moment(); // Current date

          // If the token has expired
          if (expirationDate.isBefore(currentDate)) {
            sessions.removeToken(); // Remove token
            window.location.replace('/login'); // Redirect to login
          }
        }
      }
    };

    // Initial check when component mounts
    checkTokenExpiration();

    // Set interval to regularly check token expiration (e.g., every minute)
    const intervalId = setInterval(() => {
      checkTokenExpiration();
    }, 60000); // 60000 ms = 1 minute

    // Cleanup the interval when the component is unmounted
    return () => clearInterval(intervalId);
  }, []);
};

export default useTokenExpirationCheck;
